/**
 * La franja que avisa que esto no es producción.
 *
 * Existe por una razón concreta: una build de prueba y una de verdad se ven
 * exactamente igual, y la de prueba escribe en otra base. Confundirlas es
 * cargar el trabajo de un día donde no queda, o peor, creer que un dato real se
 * guardó cuando fue a parar a la organización de pruebas.
 *
 * **Aparece por configuración de entorno, no por código.** `VITE_ENTORNO` vale
 * `produccion` sólo cuando la build es de producción; en cualquier otro caso
 * —staging, desarrollo, una variable mal escrita, una variable ausente— la
 * franja se muestra. El error seguro es el que avisa de más: una build de
 * producción con una franja que sobra es un papelón; una de prueba sin franja
 * es un dato perdido.
 *
 * Nunca se saca editando este archivo antes de compilar. Eso funciona hasta el
 * día que alguien se olvida.
 *
 * Lleva `zona-superior` porque es lo primero que se dibuja: su color tiene que
 * llegar hasta el borde de la pantalla, por detrás de la hora y la batería.
 *
 * En producción, donde esta franja no existe, ese trabajo lo hace el
 * encabezado. La decisión la toma `hayBandaDeEntorno()`: el inset NO se
 * consume —`env(safe-area-inset-top)` devuelve lo mismo aunque ya haya algo
 * arriba—, así que marcar los dos duplicaría el relleno.
 */
/** ¿Se dibuja la franja? Lo necesita el encabezado para saber si le toca a él
 *  llegar hasta el borde de la pantalla. */
export function hayBandaDeEntorno(): boolean {
  return import.meta.env.VITE_ENTORNO !== 'produccion';
}

export function BandaEntorno() {
  if (!hayBandaDeEntorno()) return null;

  return (
    <div
      role="status"
      className="zona-superior bg-[var(--aviso)] px-4 py-1 text-center text-xs font-semibold tracking-wide text-[var(--fondo)]"
      data-testid="banda-entorno"
    >
      STAGING · DATOS DE PRUEBA
    </div>
  );
}
